import { render, staticRenderFns } from "./Osa010.vue?vue&type=template&id=64f3b5be&scoped=true"
var script = {}
import style0 from "./Osa010.vue?vue&type=style&index=0&id=64f3b5be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f3b5be",
  null
  
)

export default component.exports